















































import _ from 'lodash'
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { ListMixin } from '@/mixins/list.mixin'
import { Column } from 'ant-design-vue/types/table/column'
import AssociationsModal from '@/modules/associations/components/Modal.vue'
import { api } from '@/api'
import { Filter, FilterTypes } from '@/interfaces/filter'

@Component({
  components: {
    Modal: AssociationsModal
  }
})
export default class AssociationsListView extends mixins(ListMixin) implements ListMixin {
  apiConfig = {
    path: 'associations'
  }

  pagination = null

  columns: Partial<Column>[] = [
    {
      dataIndex: 'alias',
      title: 'Алиас',
      scopedSlots: {
        customRender: 'alias'
      },
      width: 200
    },
    {
      dataIndex: 'labels',
      title: 'Лейблы',
      scopedSlots: {
        customRender: 'labels'
      },
      width: 350
    },
    {
      dataIndex: 'fieldIds',
      title: 'Идентификаторы полей',
      scopedSlots: {
        customRender: 'fieldIds'
      },
      width: 350
    },
    {
      dataIndex: 'excludeFieldIds',
      title: 'Кроме идентификаторов полей',
      scopedSlots: {
        customRender: 'excludeFieldIds'
      },
      width: 350
    },
    {
      dataIndex: 'id',
      title: '',
      scopedSlots: {
        customRender: 'actions'
      },
      align: 'center',
      width: 50
    }
  ]

  filters: Filter[] = [
    {
      name: 'alias',
      condition: '$cont',
      type: FilterTypes.INPUT,
      input: {
        placeholder: 'Алиас'
      }
    }
  ]

  clones: Record<string, any> = {}

  get canSave(): Record<string, boolean> {
    return _.transform(
      this.items,
      (result, i) => {
        result[i.id] = !_.isEqual(i, this.clones[i.id])
      },
      {}
    )
  }

  async afterFetch(result) {
    const { data: items } = result
    this.clones = _.keyBy(_.cloneDeep(items), 'id')

    // items.forEach(item => {
    //   ;['labels', 'fieldIds', 'excludeFieldIds'].forEach(prop => {
    //     item[prop] = _.orderBy(item[prop], ['length'], ['asc'])
    //   })
    // })

    return result
  }

  async onDeselect(value, node) {
    const el: HTMLDivElement = node.context.$el
    const input: HTMLInputElement | null = el.querySelector('.ant-select-search__field')
    if (!input) return

    await this.$nextTick()

    input.value = value
    input.setAttribute('value', value)

    const event = new Event('input', {
      bubbles: true,
      cancelable: true
    })

    input.dispatchEvent(event)
  }

  async update(record) {
    const { data: item } = await api.patch(`${this.apiConfig.path}/${record.id}`, record)
    const index = this.items.findIndex(i => i.id === item.id)

    this.items.splice(index, 1, item)
    this.clones[item.id] = _.cloneDeep(item)

    this.$message.success('Сохранено')
  }
}
